import { render, staticRenderFns } from "./WavePage.vue?vue&type=template&id=e409067a"
import script from "./WavePage.vue?vue&type=script&lang=js"
export * from "./WavePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports